import { createMuiTheme } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';
import pink from '@material-ui/core/colors/pink';
// import red from '@material-ui/core/colors/red';
// import orange from '@material-ui/core/colors/orange';

export default createMuiTheme({
  palette: {
    primary: { main: green[500], dark: green[800], light: green[50] }, // Purple and green play nicely together.
    secondary: { main: pink[500] }, // This is just green.A700 as hex.
  },
  typography: {
    useNextVariants: true,
    fontFamily: ['"Poppins"', 'sans-serif'].join(','),
  },
  props: {
    MuiFormControl: {
      variant: 'outlined',
    },
  },
  overrides: {
    MuiTypography: {
      h5: {
        // fontWeight: 'bold',
      },
    },
    MuiPaper: {
      rounded: {
        borderRadius: 20,
      },
    },
  },
});
